import { System } from "nopun-ecs";

import { Sound } from "../component";

export class SoundSystem extends System {
    static queries = {
        withSound: [Sound]
    };

    execute() {
        for (const entity of this.queries.withSound.added) {
            const {value: sound} = entity.get(Sound);
            sound.play();
        }
    }
}